import React, { useState } from 'react'
import _ from 'lodash'
import moment from 'moment-timezone'
import { Box, Tooltip, Typography } from '@material-ui/core'
import StatusButton from '../../Components/StatusButton'
import { useStyles } from "./styles"
import { eventStatus, ONGOING_EVENT, UPCOMING_EVENT } from './constant'
import { OutlinedButton } from '../../elements'
import EndEventPopup from './endEventPopup'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    boxShadow: theme.shadows[1],
    fontSize: 14,
    marginTop: '-5px',
    maxWidth: 'none',
    wordBreak: 'break-all'
  },
}))(Tooltip)

function EventHeader(props) {
  const classes = useStyles()
  const eventDetailStatus = _.get(props.eventDetails, 'status', '')
  const eventStartTime = _.get(props.eventDetails, 'start_date_time', '')
  const status = eventStatus(eventDetailStatus, props.eventDetails, props.timeZone)
  const [open, setOpen] = useState(false)
  const [isOngoing, setIsOngoing] = useState(false)

  const handleClickOpen = (isOngoing) => {
    setOpen(true)
    setIsOngoing(isOngoing)
  }

  const shouldDiplayButton = () => {
    if (eventDetailStatus === ONGOING_EVENT && moment().tz(props.timeZone).isBefore(moment(eventStartTime).tz(props.timeZone))) {
      return false
    }
    return ((eventDetailStatus === ONGOING_EVENT && props.ongoingStoppable) || (props.upcomingStoppable && eventDetailStatus === UPCOMING_EVENT))
  }

  return (
    <Box className={classes.headerWrapper} display="flex" flexWrap="wrap">
      <Box className={classes.headerTitleWrapper}>
        <CustomTooltip disableFocusListener title={_.get(props.eventDetails, 'name', 'Event')}>
          <Typography className={classes.headerTitle}>{_.get(props.eventDetails, 'name', 'Event')}</Typography>
        </CustomTooltip>
        {eventDetailStatus && <Box className={classes.headerStatusWrapper}>{<StatusButton text={status.label} color={status.color} />}</Box>}
      </Box>
      {!props.isViewOnly && shouldDiplayButton() && <OutlinedButton classes={classes.actionButton} label={eventDetailStatus === ONGOING_EVENT ? "End Event" : "Cancel Event"} onClick={() => handleClickOpen(eventDetailStatus === ONGOING_EVENT)} />}
      <EndEventPopup
        open={open}
        handleClosePopup={() => setOpen(false)}
        isOngoing={isOngoing}
        cancelEvent={props.cancelEvent}
        eventStartTime={eventStartTime}
        timeZone={props.timeZone}
        programDetails={props.programDetails}
      />
    </Box>
  )
}

EventHeader.defaultProps = {
  upcomingStoppable: false,
  ongoingStoppable: false
}

const mapStateToProps = ({ auth }) => {
  const { isViewOnly } = auth
  return { isViewOnly }
}

export default connect(mapStateToProps, {})(EventHeader)